import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import CircularProgress from "@mui/material/CircularProgress";

import {useTheme} from "@mui/material/styles";

import {greyishBlue200} from "assets/jss/main";

import {CustomButtonContext} from "../CustomButtonContext";

function ButtonLoader(props) {
    const theme = useTheme();
    const {disabled, buttonVariant, color} = useContext(CustomButtonContext)

    function getLoaderColor() {
        if (disabled) {
            return greyishBlue200;
        }

        if (['outlined', 'nude'].includes(buttonVariant)) {
            return theme.palette[color].outlinedText
        }

        if (theme.palette[color].text) {
            return theme.palette[color].text;
        }

        return '#fff'
    }

    return (
        <CircularProgress
            size={16}
            sx={{
                marginLeft: '8px',
                color: getLoaderColor()
            }}
        />
    );
}

export default ButtonLoader;
